// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-slider .story{padding:24px;display:flex;flex-direction:column;align-items:flex-start;box-shadow:0 0 2px rgba(0,0,0,.12),0 4px 16px rgba(0,0,0,.08);border-radius:12px}@media (max-width:767px){.card-slider .story{padding:16px}}.card-slider .story__logo{margin-bottom:16px;max-height:64px}.card-slider .story__description{margin-bottom:24px}.card-slider .story__button{margin-top:auto}", ""]);
// Exports
module.exports = exports;
